
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vvxn7_1dufc_93",
  "grid": "awsui_grid_vvxn7_1dufc_106",
  "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_1dufc_111",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_1dufc_114",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_1dufc_121",
  "grid-columns-1": "awsui_grid-columns-1_vvxn7_1dufc_124",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_1dufc_124",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_1dufc_127",
  "grid-columns-2": "awsui_grid-columns-2_vvxn7_1dufc_130",
  "grid-columns-3": "awsui_grid-columns-3_vvxn7_1dufc_136",
  "grid-columns-4": "awsui_grid-columns-4_vvxn7_1dufc_142",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_1dufc_155",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_1dufc_188"
};
  